import { Office, VirtualOffice } from 'types/firm';
import { OfficeFormValues, VirtualOfficeFormValues } from 'types/firmInfo';

// The services store is JS, so only the method used here is described.
interface ServiceLookup {
  getServiceId: (names: string | string[]) => number | number[];
}

const formatServiceForSubmit = (
  services: ServiceLookup,
  values: OfficeFormValues | VirtualOfficeFormValues,
): OfficeFormValues | VirtualOfficeFormValues => {
  const { restrictedServiceTypeIds } = values;

  return {
    ...values,
    serviceTypeIds: services.getServiceId(values.serviceTypes || []) as number[],
    specialServices: values.specialServices.map(service => service[0]),
    // An empty list must still be sent so removing all restrictions persists.
    restrictedServiceTypeIds:
      restrictedServiceTypeIds?.length > 0
        ? restrictedServiceTypeIds.map(service => service[0])
        : restrictedServiceTypeIds && [],
  };
};

export const isPhysicalOffice = (
  office: Partial<Office> | Partial<VirtualOffice>,
): office is Office => 'street' in office;

export default formatServiceForSubmit;
